module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FsnKX7/tc-custom/9780062641939.jpg?1731056015238",
      "alt": "This image is the cover for the book With God in Russia"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("With God in Russia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Polish-American priest spends twenty-three years in Soviet prisons and labor camps during the Cold War in this classic memoir of faith and survival.")]), _c('br'), _c('br'), _vm._v("After ministering in Eastern Europe during World War II, Walter Ciszek, S.J., was arrested by the Russian secret police. Accused of spying, and charged with “agitation with intent to subvert,” he was held in Moscow’s notorious Lubyanka prison for five years. The Catholic priest was then sentenced without trial to ten more years in Siberia’s notorious forced labor camp system made famous in Alexsandr Solzhenitsyn’s "), _c('i', [_vm._v("The Gulag Archipelago.")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("With God in Russia")]), _vm._v(", Ciszek reflects on his daily life as a prisoner, his unwavering faith in God, and his firm devotion to his vows and vocation. Enduring brutal conditions, Ciszek risked his life to offer spiritual guidance to fellow prisoners who could easily have exposed him for their own gains. "), _c('br'), _c('br'), _vm._v("Ciszek chronicles these experiences with grace, humility, and candor, from his secret work leading mass and hearing confessions within the prison grounds, to his participation in a major gulag uprising, to his eventual release in a 1963 prisoner exchange which astonished all who had feared he was dead.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Walter J. Ciszek, Daniel L. Flaherty\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0